import React from 'react';

const MaCXThieuComponent = () => {
  return (
    <div>
      <h1>Mã chuyến thiếu</h1>
      <p>Hiển thị các mã chuyến thiếu trong hệ thống.</p>
    </div>
  );
};

export default MaCXThieuComponent;